import React from 'react';
import { useParams } from 'react-router-dom';
import BinyanSelector from './BinyanSelector';
import VerbGameSelector from './VerbGameSelector';

function VerbsRouter() {
  const { grade } = useParams();
  
  if (grade === 'grade11') {
    return <BinyanSelector />;
  }
  
  return <VerbGameSelector />;
}

export default VerbsRouter;
